import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../shared/shared.module';
import { VivoAdminComponent } from './vivo-admin/vivo-admin.component';
import { NgbDropdownModule, NgbPaginationModule, NgbTabsetModule, NgbTypeaheadModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { VivoListComponent } from './vivo-list/vivo-list.component';
import { VivoMaintenanceComponent } from './vivo-maintenance/vivo-maintenance.component';
import { ElementUtilsModule } from '../element-utils/element-utils.module';
import { VivoFiltersModule } from '../sidebar/vivo-filters/vivo-filters.module';
import { VivoService } from './vivo.service';
import { HttpClient } from '@angular/common/http';
import { checkUIPermissionsFactory } from '../auth/ui-permissions-factory';
import { AuthService } from '~app/auth/auth.service';
import { NotificationModule } from '~app/components/notification/notification.module';

@NgModule({
  imports: [
    SharedProviderModule,
    ElementUtilsModule,
    VivoFiltersModule,
    NotificationModule,
    NgbTypeaheadModule,
    NgbTabsetModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbTooltipModule
  ],
  declarations: [VivoAdminComponent, VivoListComponent, VivoMaintenanceComponent],
  exports: [VivoAdminComponent, VivoListComponent, VivoMaintenanceComponent],
  providers: [
    {
      provide: VivoService,
      deps: [HttpClient, AuthService],
      useFactory: checkUIPermissionsFactory.bind(null, VivoService, ['vivo'])
    }
  ]
})
export class VivoModule { }
